import React from "react";
import { Link } from "react-router-dom";
import { Heart, ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function ProductCard({ product }) {
  const { addToCart, toggleWishlist, isWishlisted } = useCart();
  const discount = product.mrp > product.price ? Math.round(((product.mrp - product.price) / product.mrp) * 100) : 0;
  return (
    <div className="product-card group border hairline rounded-xl bg-white overflow-hidden transition-all hover:-translate-y-1 hover:shadow-sm" data-testid={`product-card-${product.slug}`}>
      <Link to={`/product/${product.slug}`} className="block relative aspect-square overflow-hidden bg-muted">
        {product.images?.[0] && (
          <img src={product.images[0]} alt={product.name} className="product-card-image w-full h-full object-cover" loading="lazy" />
        )}
        {discount > 0 && (
          <span className="absolute top-3 left-3 bg-espresso text-ivory text-[10px] px-2 py-1 rounded-full">-{discount}%</span>
        )}
        {product.is_new_arrival && (
          <span className="absolute top-3 right-3 bg-[#B8860B] text-ivory text-[10px] px-2 py-1 rounded-full">New</span>
        )}
        <button
          type="button"
          onClick={(e) => { e.preventDefault(); toggleWishlist(product); }}
          className="absolute bottom-3 right-3 w-9 h-9 rounded-full bg-white/90 hover:bg-white flex items-center justify-center shadow-sm"
          data-testid={`wishlist-btn-${product.slug}`}
          aria-label="Toggle wishlist"
        >
          <Heart className={`w-4 h-4 ${isWishlisted(product.product_id) ? "fill-[#B8860B] text-[#B8860B]" : ""}`} strokeWidth={1.5} />
        </button>
      </Link>
      <div className="p-4">
        <div className="text-[11px] uppercase tracking-widest text-muted-foreground mb-1">{product.material}</div>
        <Link to={`/product/${product.slug}`} className="font-serif text-lg leading-tight line-clamp-2 hover:gold-text" data-testid={`product-name-${product.slug}`}>
          {product.name}
        </Link>
          <div className="mt-3 flex items-baseline gap-2">
            <span className="font-serif text-xl">₹{product.price}</span>
            {product.mrp > product.price && <span className="text-xs text-muted-foreground line-through">₹{product.mrp}</span>}
          </div>
        <button
          onClick={() => addToCart(product, 1)}
          className="mt-3 w-full btn-gold rounded-full py-2 text-xs uppercase tracking-widest flex items-center justify-center gap-2"
          data-testid={`add-cart-${product.slug}`}
        >
          <ShoppingBag className="w-4 h-4" strokeWidth={1.5} /> Add to Cart
        </button>
      </div>
    </div>
  );
}
